import { DocumentNode } from 'graphql';
import {
  BaseApplicationProperty,
  MutationStatus,
  UpdateApplicationMutationResult,
  UpdateApplicationsQuery,
} from './BaseApplicationProperty';
import { MyApp } from '../../../types/myAppTypes';
import { ResponsibleParty } from '../../../../insights/types/RoleTypes';

/**
 * Represents the owner property of an application.
 */
export class OwnerProperty implements BaseApplicationProperty {
  field: string;
  value?: ResponsibleParty;
  label: string = 'Owner';

  constructor(field: string) {
    this.field = field;
  }

  /**
   * Sets the value of the owner property.
   * @param value - The new value for the owner property.
   */
  set(value: ResponsibleParty) {
    this.value = value;
  }

  /**
   * Returns the mutation input for the owner property.
   */
  propertyMutationInput() {
    return {
      ownerLogin: this.value?.login,
    };
  }
  /**
   * Returns the current display value of the owner property.
   * @param app - The application object.
   * @returns The current display value of the owner property.
   */
  getCurrentDisplayValue(app: MyApp): string {
    return `${app.owner?.displayName}`;
  }

  /**
   * Returns the new display value of the owner property.
   * @returns The new display value of the owner property.
   */
  getNewDisplayValue(): string {
    return (
      `${this.value?.firstName} ${this.value?.lastName} (${this.value?.login})` ||
      '-'
    );
  }
  /**
   * Returns the mutation query for updating applications.
   * @returns The mutation query document node.
   */
  mutationQuery(): DocumentNode {
    return UpdateApplicationsQuery;
  }
  /**
   * Returns the mutation result for updating applications.
   * @param data - The result data from the update application mutation.
   * @returns The mutation status array.
   */
  getMutationResult(data: UpdateApplicationMutationResult): MutationStatus[] {
    return data?.resources?.application?.updateApplications;
  }
}
